<template>
  <div class="upload-container">
    <el-upload
      ref="upload"
      :action="uploadUrl"
      :http-request="httpRequest"
      :before-upload="beforeUpload"
      :limit="limit"
      :on-exceed="handleExceed"
      :show-file-list="uploadType === 'pic' ? false : true"
      :class="uploadType === 'pic'? 'upload-box' : ''"
      :accept="accept"
      :disabled="disabled"
      :file-list.sync="fileList"
      :on-success="handleSuccess"
      :on-remove="handleRemove"
      :on-preview="handlePreview"
    >
      <div v-if="uploadType === 'pic'">
        <img v-if="imageUrl" :src="imageUrl" class="img" />
        <i v-else class="el-icon-plus uploader-icon"></i>
      </div>
      <div v-else>
        <el-button size="small" type="primary">点击上传</el-button>
      </div>
    </el-upload>
    <div class="upload-operate" v-show="imageUrl && uploadType === 'pic'">
      <el-button size="mini" @click="openPriview">查看</el-button>
      <el-button size="mini" v-if="download" @click="downloadIamge">下载</el-button>
    </div>
    <slot name="tip"></slot>
    <el-dialog :visible.sync="previewDialog" class="imageDialog">
      <img v-if="imageUrl" :src="imageUrl" width="100%" />
    </el-dialog>
  </div>
</template>

<script>
//单文件上传
import { OSSConfig } from "@/plugins/common";
import { saveAs } from "file-saver";

const client = OSSConfig();
export default {
  data() {
    return {
      uploadUrl: "",
      host:
        "http://" + client.options.bucket + "." + client.options.endpoint.host,
      previewDialog: false,
      fileName: ""
    };
  },
  props: {
    limit: [String, Number],
    value: [String],
    download: Boolean,
    disabled: {
      default: false,
      type: Boolean
    },
    hw: Array,
    //maxSize 按 M 来算
    maxSize: [String, Number],
    accept: {
      String,
      default: "image/jpeg, image/png, image/bmp"
    },
    uploadType: {
      type: String,
      default: "pic"
    },
    fileList: Array
  },
  computed: {
    imageUrl: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  },
  methods: {
    //上传图片
    httpRequest(option) {
      let file = option.file;
      let val = file.name;
      let suffix = val.substr(val.indexOf("."));
      let storeAs = "";
      if (this.uploadType === "pic") {
        storeAs = "pc/" + this.timestamp() + suffix;
      } else {
        storeAs = "pc/adv/" + this.timestamp() + suffix;
      }
      client
        .put(storeAs, file)
        .then(res => {
          this.imageUrl = res.url;
        })
        .catch(err => {
          console.log(err);
        });
    },
    //封装文件名
    timestamp() {
      let time = new Date();
      let y = time.getFullYear();
      let m = time.getMonth() + 1;
      let d = time.getDate();
      let h = time.getHours();
      let mm = time.getMinutes();
      let s = time.getSeconds();
      return (
        "" +
        y +
        this.add0(m) +
        this.add0(d) +
        this.add0(h) +
        this.add0(mm) +
        this.add0(s)
      );
    },
    add0(m) {
      return m < 10 ? "0" + m : m;
    },
    beforeUpload(file) {
      if (this.uploadType === "pic") {
        this.createReader(file).then(res => {
          let isError = false;
          if (this.accept.indexOf(file.type) < 0) {
            this.$message.error("不能上传该类型的文件");
            isError = true;
          }
          if (this.hw) {
            if (res.width != this.hw[0] || res.height != this.hw[1]) {
              this.$message.error("图片宽高必须是600*600");
              isError = true;
            }
          }
          if (this.maxSize) {
            if (file.size / 1024 / 1024 > +this.maxSize) {
              this.$message.error(
                "图片大小必须小于" + this.maxSize * 1000 + "k"
              );
              isError = true;
            }
          }
          this.$refs.upload.clearFiles();
          return !isError;
        });
      } else {
        const isVideo = this.accept.indexOf(file.type) >= 0;
        const isLt50M = file.size / 1024 / 1024 < 100;
        if (!isVideo) {
          this.$message.error("请上传正确的视频格式!");
        }
        if (!isLt50M) {
          this.$message.error("视频大小不能超过100MB");
        }
        return isVideo && isLt50M;
      }
    },
    createReader(file) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader();
        reader.onload = function(evt) {
          let image = new Image();
          image.onload = function() {
            let height = this.height;
            let width = this.width;
            resolve({
              width,
              height
            });
          };
          image.src = evt.target.result;
        };
        reader.readAsDataURL(file);
      });
    },
    //超出
    handleExceed() {},
    //打开
    openPriview() {
      this.previewDialog = true;
    },
    //下载图片
    downloadIamge() {
      if (this.imageUrl) {
        const imageName = this.imageUrl.replace("/pc/", "");
        const url = client.signatureUrl(this.imageUrl);
        let image = new Image();
        // 解决跨域 Canvas 污染问题
        image.setAttribute("crossOrigin", "anonymous");
        image.onload = function() {
          let canvas = document.createElement("canvas");
          canvas.width = image.width;
          canvas.height = image.height;
          let context = canvas.getContext("2d");
          context.drawImage(image, 0, 0, image.width, image.height);
          canvas.toBlob(function(blob) {
            saveAs(blob, imageName);
          });
        };
        image.src = url;
      }
    },
    handleSuccess(response, file, fileList) {
      this.$emit("update:fileList", fileList);
    },
    handleRemove(file, fileList) {
      this.$emit("update:fileList", fileList);
    },
    handlePreview(file) {
      window.open(file.url);
    }
  }
};
</script>

<style lang="scss">
.upload-container {
  position: relative;
}

.upload-operate {
  position: absolute;
  left: 190px;
  bottom: 10px;
  width: 60px;

  .el-button + .el-button {
    margin-left: 0;
  }
}

.upload-box .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.upload-box .el-upload:hover {
  border-color: #409eff;
}

.uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.img {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
